<div class="w-full mt-4">
  <label
    for="requestType"
    class="hidden md:block">
    {{ "contactUsForm.fileUpload.addDocument" | translate }}
    <span
      *ngIf="showMandatoryFileUploadMessage"
      class="text-red opacity-60"
      >*</span
    >
  </label>
  <p-messages
    class="md:hidden"
    *ngIf="showMandatoryFileUploadMessage"
    [value]="[mandatoryFileUploadMessage]"></p-messages>

  <p-fileUpload
    #documentUpload
    [customUpload]="true"
    (onSelect)="onFileSelected($event)"
    [multiple]="true">
    <ng-template pTemplate="content">
      <button
        pButton
        type="button"
        (click)="documentUploadChooseFile()"
        [disabled]="!enableDocumentUpload"
        class="md:hidden w-full flex items-center justify-center bg-primary text-white font-app-medium focus:shadow-none rounded-md p-4">
        <i class="pi pi-plus mr-4"></i>
        <span>{{ "contactUsForm.fileUpload.addFile" | translate }}</span>
      </button>

      <section
        class="hidden md:flex flex-col items-center border-2 border-light border-dashed rounded-xl p-6 mt-2"
        [class.opacity-50]="!enableDocumentUpload"
        [class.pointer-events-none]="!enableDocumentUpload">
        <i class="pi pi-file-arrow-up text-primary text-xl"></i>
        <span class="font-app-bold text-sm text-darkest">{{ "contactUsForm.fileUpload.dragFile" | translate }}</span>
        <span class="text-xs">{{ "contactUsForm.fileUpload.or" | translate }}</span>
        <button
          pButton
          type="button"
          (click)="documentUploadChooseFile()"
          [disabled]="!enableDocumentUpload"
          class="text-sm text-primary focus:shadow-none rounded-none">
          <span class="underline">{{ "contactUsForm.fileUpload.addFileLink" | translate }}</span>
        </button>
      </section>
    </ng-template>
    <ng-template pTemplate="file"></ng-template>
  </p-fileUpload>

  <p-messages
    *ngIf="showFileTypeErrorMessage"
    [value]="[fileTypeErrorMessage]"></p-messages>
  <p-messages
    *ngIf="showMultipleUploadErrorMessage"
    [value]="[multipleFileUploadMessage]"></p-messages>
  <p-messages
    *ngIf="showFileSizeErrorMessage"
    [value]="[fileSizeErrorMessage]"></p-messages>
</div>

